import type { ReactNode } from "react";
import { InputNumber } from "../../../../components/InputNumber/InputNumber.tsx";
import { Slider } from "../../../../components/Slider/Slider.tsx";
import { PanelSubsection } from "./PanelSubsection.tsx";

export const SliderSubsection = ({
  min,
  max,
  value,
  onChange,
  sliderName,
  sliderInformationSection,
  defaultValue,
  rightSuffix = "%",
  displayValue = true,
}: {
  min: number;
  max: number;
  value: number;
  onChange: (value: number) => void;
  sliderName?: string;
  sliderInformationSection?: ReactNode;
  defaultValue?: number;
  rightSuffix?: string;
  displayValue?: boolean;
}) =>
  sliderName ? (
    <PanelSubsection
      title={sliderName}
      infoContent={sliderInformationSection}
      rightItem={
        displayValue && (
          <InputNumber
            value={value}
            onChange={onChange}
            className="w-[56px] label-md-defaul text-primary"
            suffix={rightSuffix}
          />
        )
      }
    >
      <Slider
        value={value}
        min={min}
        max={max}
        markValue={defaultValue}
        onChange={onChange}
        className="w-full"
        displayNumber={false}
      />
    </PanelSubsection>
  ) : (
    <Slider
      value={value}
      min={min}
      max={max}
      markValue={defaultValue}
      onChange={onChange}
      className="w-full gap-200"
      displayNumber
      displayPercentage
    />
  );
